"use client";

import * as React from "react";
import { cn } from "../../shadcn/lib/utils";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "../../shadcn/components/ui/navigation-menu";
import ArrowInclinedSvg from "../../icons/ArrowInclinedSvg";
import RoundCheckSvg from "../../icons/RoundCheckSvg";
import CallIcon from "../../icons/CallIcon";
import { getSearchResults } from "services";

interface NavigationItems {
  title: string;
  value: string;
  children?: { title: string; href: string; value: string }[];
}

const navigationItemsFallback: NavigationItems[] = [
  {
    title: "Residential",
    value: "residential",
    children: [
      {
        title: "Flats",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-flat-auction-properties`
          : "/residential-flat-auction-properties",
        value: "flat",
      },
      {
        title: "Individual House",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_UR
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-individual-house-auction-properties`
          : "/residential-individual-house-auction-properties",
        value: "individual-house",
      },
      {
        title: "Bungalow",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-bungalow-auction-properties`
          : "/residential-bungalow-auction-properties",
        value: "bungalow",
      },
      {
        title: "Farm house",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-farm-house-auction-properties`
          : "/residential-farm-house-auction-properties",
        value: "farm-house",
      },
      {
        title: "Villa",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/residential-villa-auction-properties`
          : "/residential-villa-auction-properties",
        value: "villa",
      },
    ],
  },
  {
    title: "Commercial",
    value: "commercial",
    children: [
      {
        title: "Plot commercial",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-plot-commercial-auction-properties`
          : "/commercial-plot-commercial-auction-properties",
        value: "plot-commercial",
      },
      {
        title: "Mall",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-malls-auction-properties`
          : "/commercial-malls-auction-properties",
        value: "malls",
      },
      {
        title: "Office",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-office-auction-properties`
          : "/commercial-office-auction-properties",
        value: "office",
      },
      {
        title: "Shops",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-shops-auction-properties`
          : "/commercial-shops-auction-properties",
        value: "shops",
      },
      {
        title: "Others",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/commercial-auction-properties`
          : "/commercial-auction-properties",
        value: "others",
      },
    ],
  },
  {
    title: "Industrial",
    value: "industrial",
    children: [
      {
        title: "Godown",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-godowns-auction-properties`
          : "/industrial-godowns-auction-properties",
        value: "godown",
      },
      {
        title: "Plant & machinery",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties`
          : "/industrial-auction-properties",
        value: "plant-machinery",
      },
      {
        title: "Goods",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-goods-auction-properties`
          : "industrial-goods-auction-properties",
        value: "goods",
      },
      {
        title: "Plot industrial",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-plot-auction-properties`
          : "/industrial-plot-auction-properties",
        value: "plot-industrial",
      },
      {
        title: "Shed with plant & machinery",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties`
          : "/industrial-auction-properties",
        value: "shed-with-plant-machinery",
      },
      {
        title: "Industrial shed",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties`
          : "/industrial-auction-properties",
        value: "industrial-shed",
      },
      {
        title: "Industrial land",
        href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
          ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/industrial-auction-properties`
          : "/industrial-auction-properties",
        value: "industrial-land",
      },
    ],
  },
  // {
  //   title: "Others",
  //   value: "others",
  // },
];

if (process.env.NEXT_PUBLIC_PYP_ENABLE === "true")
  navigationItemsFallback.push({
    title: "Private",
    value: "private",
  });

export function NavigationMenuCards(props: any) {
  const [activeNavItem, setActiveNavItem] = React.useState<string>();
  const [navigationItems, setNavigationItems] = React.useState<
    NavigationItems[]
  >(navigationItemsFallback);

  const init = async () => {
    const data: any = await getSearchResults({
      searches: [
        {
          collection: "properties",
          q: "*",
          facet_by: "dump.asset.sub_asset_type_slug",
          facet_return_parent: "dump.asset.sub_asset_type_slug",
          max_facet_values: "500",
          per_page: 0,
        },
      ],
    });
    const filteredPropertiesData = data.results
      .flatMap(
        (result: any) =>
          (result?.facet_counts &&
            result?.facet_counts[0]?.counts.map((facet: any) => {
              return {
                title: facet?.parent?.asset_type_name,
                value: facet?.parent?.asset_type_slug,
                children: [
                  {
                    title: facet?.parent?.sub_asset_type_name,
                    href: process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                      ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/${facet?.parent?.asset_type_slug}-${facet?.parent?.sub_asset_type_slug}-auction-properties`
                      : `/${facet?.parent?.asset_type_slug}-${facet?.parent?.sub_asset_type_slug}-auction-properties`,
                    value: facet?.parent?.sub_asset_type_slug,
                  },
                ],
              };
            })) ||
          []
      )
      .reduce((acc: NavigationItems[], item: any) => {
        const existingCategory: any = acc.find(
          (cat) => cat.title === item.title
        );
        if (existingCategory) {
          existingCategory.children.push(...item.children);
        } else {
          acc.push(item);
        }
        return acc;
      }, [])
      .sort(
        (a: any, b: any) =>
          (a.value === "others" ? 1 : 0) - (b.value === "others" ? 1 : 0)
      );

    if (filteredPropertiesData?.length > 0) {
      let filterData = filteredPropertiesData.filter(
        (item: any) => item?.title !== "others"
      );

      if (process.env.NEXT_PUBLIC_PYP_ENABLE === "true")
        filterData.push({
          title: "Private",
          value: "private",
        });
      setNavigationItems(filterData);
    } else {
      setNavigationItems(navigationItemsFallback);
    }
  };

  React.useEffect(() => {
    (async () => {
      await init();
    })();
  }, []);

  return (
    <NavigationMenu className="z-20">
      {navigationItems?.map((item) => (
        <NavigationMenuList key={`${item.value}_nav_item`}>
          <NavigationMenuItem className="group">
            <NavigationMenuTrigger
              className="mid:px-[19px] mid:pt-6 mid:pb-5 capitalize font-spaceGrotesk font-normal leading-10 text-brand-textBlack text-web-body-sm border-b-transparent border-b-4 hover:border-b-transparent hover:border-b-4"
              onClick={() => {
                if (item.value === "private")
                  window.location.href = "/private-properties";
                else setActiveNavItem(item.value);
              }}
            >
              {item.title}
              <div
                className={cn(
                  "h-1 w-full absolute bottom-0 left-0 rounded-sm group-hover:bg-brand-orange",
                  item.value === activeNavItem && "bg-brand-orange"
                )}
              />{" "}
            </NavigationMenuTrigger>
            {item?.value !== "private" && (
              <NavigationMenuContent
                onMouseEnter={() => setActiveNavItem(item.value)} // Set hover state
                onMouseLeave={() => setActiveNavItem("")}
              >
                <div className="flex bg-white shadow-xl ring-1 ring-gray-900/5 h-custom-407 w-[648px]">
                  <div className="pt-custom-51 px-24">
                    <ul className="space-y-6 w-[126px]">
                      <li className="font-openSans text-web-body-md text-[#E0E0E0] font-semibold leading-4">
                        <p className="">CATEGORIES</p>
                      </li>

                      {item?.children?.map((childItem: any) => {
                        return (
                          <li
                            key={childItem.value}
                            className="font-openSans capitalize text-web-body-md text-brand-textGrey font-normal leading-4"
                          >
                            <a href={childItem.href}>{childItem.title}</a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>

                  <div className="mt-[37px] ml-9  flex  w-full ">
                    <div
                      className=" bg-[#F8F8F8] pl-8 pt-5 h-[241px] w-[244px] bg-wave-pattern1 bg-no-repeat"
                      style={{
                        clipPath:
                          "polygon(0% 0%, 100% 0%, 100% 80%, 80% 100%, 0% 100%)",
                        backgroundPosition: "16px -3px", // Set custom position here
                      }}
                    >
                      {/* Call Icon */}
                      <div className="">
                        <CallIcon height="25" width="25" />
                      </div>

                      {/* Heading */}
                      <h1 className="font-spaceGrotesk font-bold text-web-subheading text-brand-textGrey mt-[13px] w-[140px] h-[19px]">
                        Contact Us
                      </h1>

                      {/* List */}
                      <ul className="space-y-[13px] mt-[19px]">
                        <li className="flex items-center">
                          <RoundCheckSvg />
                          <p className="pl-2 font-openSans font-normal text-web-body-sm leading-4 text-brand-textGrey">
                            24/7 Support
                          </p>
                        </li>
                        <li className="flex items-center">
                          <RoundCheckSvg />
                          <p className="pl-2 font-openSans font-normal text-web-body-sm leading-4 text-brand-textGrey">
                            Expert Assistance
                          </p>
                        </li>
                        <li className="flex items-center">
                          <RoundCheckSvg />
                          <p className="pl-2 font-openSans font-normal text-web-body-sm leading-4 text-brand-textGrey">
                            Finance Assistance
                          </p>
                        </li>
                      </ul>

                      {/* Talk to expert */}
                      <a
                        href={
                          process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL
                            ? `${process.env.NEXT_PUBLIC_AUCTION_BAZAAR_WEB_URL}/contactus`
                            : "/contactus"
                        }
                        className="flex mt-[37px]"
                      >
                        <p className="font-openSans font-semibold text-web-body-sm text-brand-orange">
                          Talk to our Expert
                        </p>
                        <div className="h-[14px] w-[14px] mt-[2px]">
                          <ArrowInclinedSvg></ArrowInclinedSvg>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </NavigationMenuContent>
            )}
          </NavigationMenuItem>
        </NavigationMenuList>
      ))}
    </NavigationMenu>
  );
}
